import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/parking`;

export default {
  async listParkings(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/listParkings`, {
        params: params
      });

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async getParking(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/getParking`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        status: error.status,
        error: true
      };
    }
  },

  async toggleFavorite(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/toggleFavourite`, {
        params: params
      });

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  // isRemovedParking(parking) {
  //   return parking.status === 'REMOVED'
  // },

  isMaintenanceParking(parking) {
    return ['BLOCKED', 'MAINTENANCE'].indexOf(parking.status) > -1;
  },

  isBuildingParking(parking) {
    return ['BUILDING', 'COMING_SOON'].indexOf(parking.status) > -1;
  },

  isOfflineParking(parking) {
    return parking.status === 'OFFLINE';
  },

  isActivedParking(parking) {
    return parking.status === 'ACTIVED';
  },

  isCommingSoonParking(parking) {
    switch (parking.status) {
      case 'ACTIVED':
      case 'OFFLINE':
      case 'MAINTENANCE':
      case 'BLOCKED':
        return false;
      default:
        return true
    }
  },

  availableParkingMarkers() {
    return [
      'WSP',
      'WSP_E',
      'OTHER',
      'OTHER_E',
      'FUEL',
      'WASH',
      'ITV',
      'WORKSTATION',
      'WSP_TRAIN',
      'WSP_TRAIN_E',
      'WSP_AIRPORT',
      'WSP_AIRPORT_E',
      'OTHER_TRAIN',
      'OTHER_TRAIN_E',
      'OTHER_AIRPORT',
      'OTHER_AIRPORT_E'
    ];
  },
};
